import { EspecialidadeFilial } from "../especialidade/especialidade-filial";
import { MedicoFilial } from "../medico/medico-filial";

export class Filial {

    id: number = 0;

    nome: string = '';

    cnpj: string = '';

    logradouro: string = '';

    complemento: string = '';

    numero: string = '';

    bairro: string = '';

    cidade: string = '';

    estado: string = '';

    cep: string = '';

    fone: string = '';
    
    medicoFilial: Array<MedicoFilial> = [];

    especialidadeFilial: Array<EspecialidadeFilial> = [];

    localAtendimento: string | null = null;

    constructor() {
    }
}
